import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export default function KalemlerBarChart({ periodReport, showAmount }) {
  const chartData = periodReport.products.map((item) => ({
    name: item.name,
    totalAmount: item.totalAmount,
    totalPrice: item.totalPrice,
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        {showAmount && (
          <Bar dataKey="totalAmount" fill="#8884d8" name="Total Amount" />
        )}
        {!showAmount && (
          <Bar dataKey="totalPrice" fill="#82ca9d" name="Total Price" />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
}
